import React, { useEffect } from 'react'
import { useStoreActions, useStoreState } from 'easy-peasy'
// import { Col } from 'reactstrap'
import styled, { css } from 'styled-components'
import media from '../../utils/media'
import BtnClose from './BtnClose'
import ModalLeave from './ModalLeave'

const Background = styled.div`
  width: 100%;
  height: 100%;
  position: fixed;
  z-index: 9998;
  top: 0;
  left: 0;
  background: rgba(129, 129, 129, 0.2);
  height: 100vh;
  overflow-y: hidden;
`

const Container = styled.div`
  position: fixed;
  height: 100%;
  width: 100%;
  max-width: calc(100vw - 71px);
  max-height: calc(100vh - 71px);
  z-index: 9998;
  display: block;
  background-color: #ffffff;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  ${media.mobileL`
    max-width: 100vw;
    max-height: 100vh;
  `}
`

const Header = styled.div`
  height: 45px;
  z-index: 9999;
  position: relative;
`

const ChildContainer = styled.div`
  width: 100%;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  ${media.tablet`
    max-width: 640px;
    padding: 15px;
  `}
  ${media.tabletS`
    margin: 0 auto;
    padding: auto;
  `}
  .form-component {
    height: calc(100vh - 100px);
    max-height: 800px;
    width: 100%;
    margin: 20px auto 0;
    max-width: 993px;
    @media screen and (max-height: 860px) {
      ${props =>
        props.locale === 'en-us' &&
        css`
          max-height: 860px;
          overflow-y: auto;
        `}
    }
    @media screen and (max-height: 819px) {
      max-height: 830px;
      overflow-y: auto;
    }
    @media screen and (max-height: 1024) {
      height: calc(100vh - 120px);
      max-height: 750px;
      margin: 0 auto 0;
      ${props =>
        props.locale === 'en-us' &&
        css`
          max-height: 795px;
        `}
    }
    @media screen and (max-height: 768px) {
      max-height: 736px;
      margin: 17px auto 0;
      max-width: 640px;
      ${props =>
        props.locale === 'en-us' &&
        css`
          max-height: 830px;
        `}
    }
    ${media.tabletS`
      height: calc(100vh - 87px);
      max-height: 100%;
      overflow-y: auto;
    `}
    .form-title {
      p > strong {
        font-weight: 600 !important;
      }
      ${media.mobileL`
        padding: 0 20%;
        margin-bottom: calc(${props =>
          props.marginBTitle ? props.marginBTitle : 18}px/2);
        p {
          font-size: calc(${props =>
            props.titleSize ? props.titleSize : 35}px/1.6);
        }
      `}
      ${media.mobileS`
        padding: 0 15%;
      `}
    }
    .form-subtitle {
      ${media.mobileL`
        padding: 0 17px;
        p {
            font-size: 25px;
            line-height: 1.18;
            letter-spacing: 0.31px;
          strong {
            font-weight: normal !important;
          }
        }
      `}
    }
  }
`

export default function Modal({ children, config }) {
  const [openModal, locale] = useStoreState(state => [
    state.form.openModal,
    state.locale.locale,
  ])

  const [setOpenModalLeave] = useStoreActions(actions => [
    actions.form.setOpenModalLeave,
  ])

  useEffect(() => {
    if (openModal) {
      document.body.style.position = 'fixed'
      document.body.style.top = '0'
      document.body.style.left = '0'
      document.body.style.right = '0'
      document.body.style.bottom = '0'
    } else {
      document.body.style.position = 'relative'
    }
  }, [openModal])

  return (
    <>
      <ModalLeave config={config} />
      {openModal && (
        <Background>
          <Container>
            <Header>
              {/* <Col className="align-items-center h-100 position-relative"> */}
              <div className="header-btn-close">
                <BtnClose
                  action={() => setOpenModalLeave(true)}
                  width="14"
                  height="14"
                />
              </div>
            </Header>
            <ChildContainer
              className="modal-children"
              locale={locale}
            >
              {children}
            </ChildContainer>
          </Container>
        </Background>
      )}
    </>
  )
}
